import { Link } from 'react-router-dom';
import Logo from './../../assets/img/no-img.jpg';
import { useState, useContext, useRef, useEffect } from 'react';
import { LayoutContext } from '../../Context/LayoutContext';
import Skeleton from '../Common/Skeleton';
import NotificationIcon from './../../assets/img/icons8-notification-64.png';
import NoNotificationIcon from './../../assets/img/icons8-no-reminders-80.png';
import axios from 'axios';
import { API_URL } from './../../Config/constant';
import toast, { Toaster } from 'react-hot-toast';
export default function Header() {
  const {
    handleLogout,
    isMobile,
    mobileMenuOpen,
    setMobileMenuOpen,
    userInformation,
    apiToken,
    logoUrl,
    companyInfoLoaded, // Add this line
    companyName,
  } = useContext(LayoutContext);
  const [showProfileDropDown, setShowProfileDropDown] = useState(false);
  const [showProfileMobileDropDown, setShowProfileMobileDropDown] = useState(false);
  const [showNotificationTrey, setShowNotificationTrey] = useState(false);
  const [notification, setNotification] = useState([]);
  const [logoLoaded, setLogoLoaded] = useState(false);
  const divRef = useRef(null);
  const profileDivRef = useRef(null);
  const handleClickOutside = (event) => {
    if (divRef.current && !divRef.current.contains(event.target)) {
      setShowNotificationTrey(false);
    }
  };
  const handleClickOutsideProfile = (event) => {
    if (profileDivRef.current && !profileDivRef.current.contains(event.target)) {
      setShowProfileDropDown(false);
    }
  };
  const getNotification = () => {
    axios
      .post(
        `${API_URL}api/notification`,
        {
          EmployeeID: userInformation?.EmployeeID,
        },
        {
          headers: {
            Authorization: `Bearer ${apiToken}`,
          },
        }
      )
      .then((res) => {
        const { result } = res?.data;
        setNotification(result);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    if (apiToken && userInformation && companyInfoLoaded) {
      // Modify this line
      getNotification();
    }
  }, [apiToken, userInformation, companyInfoLoaded]); // Modify this line
  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('mousedown', handleClickOutsideProfile);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('mousedown', handleClickOutsideProfile);
    };
  }, []);
  useEffect(() => {
    if (logoUrl) {
      const img = new Image();
      img.src = logoUrl;
      img.onload = () => setLogoLoaded(true);
    }
  }, [logoUrl]);
  useEffect(() => {
    document.title = `${companyName}  - HRMS`;
  }, [companyName]);
  const handleProfileMiniDropdown = () => {
    setShowProfileDropDown(!showProfileDropDown);
  };
  const handleProfileMobileMiniDropdown = () => {
    setShowProfileMobileDropDown(!showProfileMobileDropDown);
  };
  const toggleMenu = () => {
    if (isMobile) {
      setMobileMenuOpen(!mobileMenuOpen);
      document.documentElement.classList.add('menu-opened');
    } else {
      document.body.classList.toggle('mini-sidebar');
    }
  };
  const readNotification = (NotificationID) => {
    axios
      .post(
        `${API_URL}api/read-notification`,
        {
          NotificationID: NotificationID,
        },
        {
          headers: {
            Authorization: `Bearer ${apiToken}`,
          },
        }
      )
      .then((res) => {
        const { message, status } = res?.data;
        if (status === 200) {
          toast.success(message);
          getNotification();
        } else {
          toast.error(message);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div className="header">
      <div className="header-left">
        <Link to="/dahsboard" className="logo">
          {logoLoaded ? (
            <img src={logoUrl} alt="Logo" />
          ) : (
            <Skeleton height={'30px'} width={'100px'} />
          )}
        </Link>
        <Link to="/dahsboard" className="logo logo-small">
          {logoLoaded ? (
            <img src={logoUrl} alt="Logo" width="30" height="30" />
          ) : (
            <Skeleton height={'30px'} width={'30px'} />
          )}
        </Link>
        <Link to="#" id="toggle_btn" onClick={toggleMenu}>
          <span className="bar-icon">
            <span></span>
            <span></span>
            <span></span>
          </span>
        </Link>
      </div>

      <Link to="#" className="mobile_btn" id="mobile_btn" onClick={toggleMenu}>
        <i className="fas fa-bars"></i>
      </Link>

      <ul className="nav user-menu">
        <li className="nav-item dropdown show" ref={divRef}>
          <Link
            to="#"
            className="dropdown-toggle nav-link pr-0"
            data-toggle="dropdown"
            onClick={() => setShowNotificationTrey(!showNotificationTrey)}
          >
            <img src={NotificationIcon} alt="notification" style={{ height: '25px' }} />{' '}
            <span className="badge badge-pill"></span>
          </Link>
          <div
            className={`dropdown-menu notifications ${showNotificationTrey ? 'show' : ''}`}
            style={{
              left: '-85px',
            }}
          >
            <div className="topnav-dropdown-header">
              <span className="notification-title">Notifications</span>
            </div>
            <div className="noti-content">
              <ul className="notification-list">
                {notification.length ? (
                  notification.map((v, i) => {
                    return (
                      <li
                        className="notification-message"
                        key={i}
                        style={!v?.IsRead ? { backgroundColor: '#e3ffd1' } : {}}
                        onClick={() => readNotification(v?.NotificationID)}
                      >
                        <Link to="#">
                          <div className="media">
                            <span className="avatar avatar-sm">
                              <img
                                className="avatar-img rounded-circle"
                                alt=""
                                src={v?.ProfilePhoto}
                              />
                            </span>
                            <div className="media-body">
                              <p className="noti-details">
                                <div className="noti-title">{v?.Title}</div>
                                <div>{v?.Message}</div>
                              </p>
                              <p className="noti-time">
                                <span className="notification-time">{v?.time_ago}</span>
                              </p>
                            </div>
                          </div>
                        </Link>
                      </li>
                    );
                  })
                ) : (
                  <div className="notification-text">
                    <div>
                      <img src={NoNotificationIcon} alt="NoNotificationIcon" />
                    </div>
                    <div>There is no notification for you.</div>
                  </div>
                )}
              </ul>
            </div>
            <div className="topnav-dropdown-footer">
              <Link to="#">View all Notifications</Link>
            </div>
          </div>
        </li>
        <li className="nav-item dropdown has-arrow main-drop" ref={profileDivRef}>
          <Link
            to="#"
            className="dropdown-toggle nav-link flex-property"
            data-toggle="dropdown"
            onClick={handleProfileMiniDropdown}
          >
            {userInformation?.ProfilePicture ? (
              <div className="user-img">
                <img src={`${userInformation?.ProfilePicture}`} alt="" />
              </div>
            ) : (
              <Skeleton height={'48px'} width={'48px'} radius={'50%'} />
            )}
            {userInformation?.FirstName && userInformation?.LastName ? (
              <div>{`${userInformation?.FirstName} ${userInformation?.LastName}`} </div>
            ) : (
              <div className="row-skeleton">
                <Skeleton height={'10px'} width={'110px'} radius={'5px'} />
                <Skeleton height={'10px'} width={'150px'} radius={'5px'} />
              </div>
            )}
          </Link>
          <div className={`dropdown-menu ${showProfileDropDown ? 'show' : ''}`}>
            <Link
              className="dropdown-item"
              to={`/employees/${userInformation?.EmployeeID}`}
              onClick={handleProfileMiniDropdown}
            >
              <i className="fa-regular fa-user mr-1"></i> Profile
            </Link>
            <Link className="dropdown-item" to="#" onClick={handleLogout}>
              <i className="fa fa-sign-out mr-1"></i> Logout
            </Link>
          </div>
        </li>
      </ul>
      <div className="dropdown mobile-user-menu">
        <Link
          to="#"
          className="nav-link dropdown-toggle"
          data-toggle="dropdown"
          aria-expanded="false"
          onClick={handleProfileMobileMiniDropdown}
        >
          <i className="fa fa-ellipsis-v"></i>
        </Link>
        <div
          className={`dropdown-menu dropdown-menu-right ${showProfileMobileDropDown ? 'show' : ''}`}
        >
          <Link className="dropdown-item" to="#" onClick={handleProfileMobileMiniDropdown}>
            My Profile
          </Link>
          <Link className="dropdown-item" to="#" onClick={handleLogout}>
            Logout
          </Link>
        </div>
      </div>
      <Toaster />
    </div>
  );
}
